import React from 'react';
import {
  FactCheck,
  QuestionAnswer,
  ThumbDown,
  ThumbUp,
} from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { userRoles } from 'constants/constants';
import { useTranslation } from 'react-i18next';
import { Project } from 'redux/projectSlice';
import { commentActionEnum } from 'redux/conductInspectionSlice';
import './CommentOptions.scss';

export type CommentOptionsProps = {
  project: Project;
  currentStatus: commentActionEnum | null;
  commentOption: string;
  isInspectorDoerSame: boolean | undefined;
  onCommentOptionChange: (option: string) => void;
};

export const CommentOptions: React.FC<CommentOptionsProps> = ({
  project,
  currentStatus,
  commentOption,
  isInspectorDoerSame,
  onCommentOptionChange,
}) => {
  const { t } = useTranslation();
  const handleChange = (
    _: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    onCommentOptionChange(newAlignment);
  };

  const renderCommentOptions = () => {
    const approveButton = (
      <ToggleButtonGroup
        color="primary"
        value={commentOption}
        exclusive
        onChange={handleChange}
      >
        <ToggleButton
          size="small"
          color="primary"
          className="comment-option-btn"
          value={commentActionEnum.Approve}
        >
          <ThumbUp fontSize="small" color="success" className="mx-1" />
          {t('btn_approve')}
        </ToggleButton>
        <ToggleButton
          size="small"
          color="primary"
          className="comment-option-btn"
          value={commentActionEnum.Disapprove}
        >
          <ThumbDown fontSize="small" color="error" className="mx-1" />
          {t('btn_disapprove')}
        </ToggleButton>
        <ToggleButton
          size="small"
          color="primary"
          className="comment-option-btn"
          value={commentActionEnum.Comment}
        >
          <QuestionAnswer fontSize="small" className="mx-1" />
          {t('btn_comment')}
        </ToggleButton>
      </ToggleButtonGroup>
    );
    if (project?.role !== userRoles.DOER) {
      if (isInspectorDoerSame) {
        return approveButton;
      }
      return (
        currentStatus !== commentActionEnum.Disapprove &&
        currentStatus !== commentActionEnum.TaskRaised && approveButton
      );
    }

    return (
      currentStatus !== commentActionEnum.SendForApproval && (
        <ToggleButtonGroup
          color="primary"
          value={commentOption}
          exclusive
          onChange={handleChange}
        >
          <ToggleButton
            size="small"
            color="primary"
            className="comment-option-btn"
            value={commentActionEnum.SendForApproval}
          >
            <FactCheck fontSize="small" color="warning" className="mx-1" />
            {t('btn_send_for_approval')}
          </ToggleButton>
          <ToggleButton
            size="small"
            color="primary"
            className="comment-option-btn comment"
            value={commentActionEnum.Comment}
          >
            <QuestionAnswer fontSize="small" className="mx-1 comment-icon" />
            {t('btn_comment')}
          </ToggleButton>
        </ToggleButtonGroup>
      )
    );
  };
  return renderCommentOptions() || null;
};
